/* PDP - Sticky add to cart JS */

document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-product-bar');
  const productInfo = document.querySelector('.product-information');

  if (!stickyBar) return;

  // Hidden sticky bar must not sit in the tab order (visibility:hidden alone is not enough).
  stickyBar.setAttribute('inert', '');

  function setStickyVisible(visible) {
    stickyBar.classList.toggle('show', visible);
    if (visible) {
      stickyBar.removeAttribute('inert');
    } else {
      stickyBar.setAttribute('inert', '');
    }
  }

  window.addEventListener('scroll', function () {
    if (!productInfo) return;

    const rect = productInfo.getBoundingClientRect();

    // When section goes above viewport
    if (rect.bottom < 0) {
      setStickyVisible(true);
    } else {
      setStickyVisible(false);
    }
  });
});

// The sticky bar is a separate section, so it never gets variant updates. The page fetched for
// the new variant already renders it for that variant: copy it over (BBFD-455).
document.addEventListener(
  'variant:update',
  async function (e) {
    const stickyBar = document.getElementById('sticky-product-bar');
    const fresh = e.detail?.data?.html?.getElementById?.('sticky-product-bar');
    if (!stickyBar || !fresh) return;

    // Clone now: product-form.js reads the same html after this capture listener, and morph moves nodes.
    const freshCopy = fresh.cloneNode(true);
    const { morph } = await import('@theme/morph');

    // Leave Shopify's hydrated wallet buttons alone; they read the variant id from the form at click time.
    for (const tree of [stickyBar, freshCopy]) {
      tree
        .querySelector('.accelerated-checkout-block')
        ?.setAttribute('data-skip-subtree-update', '');
    }
    const quantity = stickyBar.querySelector('input[name="quantity"]')?.value;

    morph(stickyBar, freshCopy);

    const quantityInput = stickyBar.querySelector('input[name="quantity"]');
    if (quantityInput && quantity) quantityInput.value = quantity;
    syncStickyNotifyMe();
  },
  true
);

// Klaviyo's back-in-stock button lives in the main form only; mirror it in the sticky bar
// so sold-out variants show Notify me there too, with a single Klaviyo trigger (BBFD-455).
function syncStickyNotifyMe() {
  const stickyBar = document.getElementById('sticky-product-bar');
  const slot = stickyBar?.querySelector('add-to-cart-component');
  if (!slot) return;

  const klaviyoButton = document.querySelector('#klaviyo-bis-button-container button');
  let proxy = stickyBar.querySelector('.sticky-notify-me');

  if (!klaviyoButton) {
    proxy?.remove();
    slot.hidden = false;
    return;
  }

  if (!proxy) {
    proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = 'button add-to-cart-button-style sticky-notify-me';
    proxy.addEventListener('click', function () {
      document.querySelector('#klaviyo-bis-button-container button')?.click();
    });
    slot.after(proxy);
  }
  proxy.textContent = klaviyoButton.textContent.trim();
  slot.hidden = true;
}

document.addEventListener('DOMContentLoaded', function () {
  const marker = document.querySelector('.klaviyo-bis-trigger');
  if (!marker || !document.getElementById('sticky-product-bar')) return;

  // Klaviyo inserts its container next to the marker, then builds the button inside it, so watch the subtree.
  new MutationObserver(syncStickyNotifyMe).observe(marker.parentElement, {
    childList: true,
    subtree: true,
  });
  syncStickyNotifyMe();
});

document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('.add-to-cart-button');
    if (!btn) return;

    const form = btn.closest('form');
    if (!form) return;

    const wrapper = document.querySelector('.personalization-wrapper');

    if (!wrapper) return;

    const input = wrapper.querySelector('.personalization-input');
    const error = wrapper.querySelector('.personalization-error');

    const value = input?.value.trim() || '';

    if (error) error.textContent = '';

    if (input && value === '') {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (error) {
        error.textContent = 'Personalization is required.';
      }

      input.focus();
      return;
    }

    if (input && value !== '') {
      const fieldName = `properties[personalization-message]`;

      let hidden = form.querySelector(`input[name="${fieldName}"]`);

      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = `${fieldName}`;
        form.appendChild(hidden);
      }

      hidden.value = value;
    }
  },
  true
);
